<template>
  <button
    type="button"
    class="btn btn-danger gap-2"
    :disabled="disabled"
    :loading="disabled"
    @click="$emit('click')"
  >
    <HeartIcon class="w-5 h-5" />

    <span class="sr-only xs:not-sr-only">{{ text }}</span>
  </button>
</template>

<script>
import HeartIcon from '@/assets/svg/icons/heart.svg?inline'

export default {
  components: {
    HeartIcon,
  },

  props: {
    disabled: { type: Boolean, default: false },
    text: { type: String, default: '' },
  },
}
</script>
